/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Illegal_Transaction_ContentInputs */

const en_dialog_illegal_transaction_content = /** @type {(inputs: Dialog_Illegal_Transaction_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your payment was successful, but your subscription hasn't been linked to your Forest account yet. Don't worry! Please tap Restore Purchases to resolve this.`)
};

const ar_dialog_illegal_transaction_content = /** @type {(inputs: Dialog_Illegal_Transaction_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لقد تم الدفع بنجاح، ولكن لم يتم ربط الاشتراك بحساب Forest الخاص بك بعد. لا تقلق! يرجى النقر على "استعادة المشتريات" لحل هذه المشكلة.`)
};

const de_dialog_illegal_transaction_content = /** @type {(inputs: Dialog_Illegal_Transaction_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre Zahlung war erfolgreich, aber das Abonnement ist noch nicht mit Ihrem Forest-Konto verknüpft. Keine Sorge! Bitte tippen Sie auf „Käufe wiederherstellen“, um das Problem zu lösen.`)
};

const es_dialog_illegal_transaction_content = /** @type {(inputs: Dialog_Illegal_Transaction_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu pago se ha realizado con éxito, pero la suscripción aún no está vinculada a tu cuenta de Forest. ¡No te preocupes! Toca "Restaurar compras" para resolverlo.`)
};

const fr_dialog_illegal_transaction_content = /** @type {(inputs: Dialog_Illegal_Transaction_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre paiement a réussi, mais l’abonnement n’est pas encore lié à votre compte Forest. Ne vous inquiétez pas ! Veuillez appuyer sur « Récupération des achats » pour résoudre ce problème.`)
};

const it_dialog_illegal_transaction_content = /** @type {(inputs: Dialog_Illegal_Transaction_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il pagamento è andato a buon fine, ma l’abbonamento non è ancora collegato al tuo account Forest. Non preoccuparti! Tocca "Ripristina gli acquisti" per risolvere il problema.`)
};

const ja_dialog_illegal_transaction_content = /** @type {(inputs: Dialog_Illegal_Transaction_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お支払いは完了しましたが、サブスクリプションが Forest アカウントに連携されていません。ご安心ください！「購入の復元」をタップして解決してください。`)
};

const ko_dialog_illegal_transaction_content = /** @type {(inputs: Dialog_Illegal_Transaction_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`결제는 완료되었지만, 구독이 Forest 계정과 연결되지 않았습니다. 걱정하지 마세요! '구매 복원'을 눌러 이 문제를 해결해 주세요.`)
};

const pt_br_dialog_illegal_transaction_content = /** @type {(inputs: Dialog_Illegal_Transaction_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu pagamento foi bem-sucedido, mas a assinatura ainda não está vinculada à sua conta Forest. Não se preocupe! Toque em "Restaurar compras" para resolver isso.`)
};

const ru_dialog_illegal_transaction_content = /** @type {(inputs: Dialog_Illegal_Transaction_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оплата прошла успешно, но подписка ещё не привязана к вашему аккаунту Forest. Не волнуйтесь! Нажмите «Восстановить покупки», чтобы решить проблему.`)
};

const th_dialog_illegal_transaction_content = /** @type {(inputs: Dialog_Illegal_Transaction_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การชำระเงินของคุณเสร็จสมบูรณ์แล้ว แต่การสมัครสมาชิกยังไม่ได้เชื่อมกับบัญชี Forest ของคุณ ไม่ต้องกังวล! โปรดแตะ "กู้คืนการซื้อ" เพื่อแก้ไขปัญหานี้`)
};

const tr_dialog_illegal_transaction_content = /** @type {(inputs: Dialog_Illegal_Transaction_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ödemeniz başarılı oldu ancak abonelik henüz Forest hesabınıza bağlanmadı. Endişelenmeyin! Çözmek için lütfen "Satın Alımları Geri Yükle"ye dokunun.`)
};

const zh_cn_dialog_illegal_transaction_content = /** @type {(inputs: Dialog_Illegal_Transaction_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的付款已完成，但 Plus 会员资格尚未与 Forest 账号连结。别担心！请点击“恢复购买”来解决这个问题。`)
};

const zh_tw_dialog_illegal_transaction_content = /** @type {(inputs: Dialog_Illegal_Transaction_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的付款已完成，但訂閱資格尚未與 Forest 帳號連結。別擔心！請點擊「還原購買」來解決這個問題。`)
};

/**
* | output |
* | --- |
* | "Your payment was successful, but your subscription hasn't been linked to your Forest account yet. Don't worry! Please tap Restore Purchases to resolve this." |
*
* @param {Dialog_Illegal_Transaction_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_illegal_transaction_content = /** @type {((inputs?: Dialog_Illegal_Transaction_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Illegal_Transaction_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_illegal_transaction_content(inputs)
	if (locale === "ar") return ar_dialog_illegal_transaction_content(inputs)
	if (locale === "de") return de_dialog_illegal_transaction_content(inputs)
	if (locale === "es") return es_dialog_illegal_transaction_content(inputs)
	if (locale === "fr") return fr_dialog_illegal_transaction_content(inputs)
	if (locale === "it") return it_dialog_illegal_transaction_content(inputs)
	if (locale === "ja") return ja_dialog_illegal_transaction_content(inputs)
	if (locale === "ko") return ko_dialog_illegal_transaction_content(inputs)
	if (locale === "pt_br") return pt_br_dialog_illegal_transaction_content(inputs)
	if (locale === "ru") return ru_dialog_illegal_transaction_content(inputs)
	if (locale === "th") return th_dialog_illegal_transaction_content(inputs)
	if (locale === "tr") return tr_dialog_illegal_transaction_content(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_illegal_transaction_content(inputs)
	return zh_tw_dialog_illegal_transaction_content(inputs)
});